import React, { useRef, useState } from "react";
import { Button, Box, CircularProgress, FormGroup, FormControlLabel, Switch } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";

const ExposureReportModal = (props) => {
	
	const compromisedAccounts = useRef(null);
	const passwordsLeaked = useRef(null);
	const dataItemsLeaked = useRef(null);
	let [ useClearbitLogo, setUseClearbitLogo ] = useState(true);
	let [ hideImage, setHideImage ] = useState(false);
	let [ showClearbitToggle, setShowClearbitToggle ] = useState(false);
	
	const handleClose = () => {
		setHideImage(false);
		setShowClearbitToggle(false);
		props.onClose()
	};
	
	const handleAdvanced = () => {
		handleSubmit(true);
	};
	
	const handleSubmit = (advanced) => {
		const darkWebDetails = {
			compromisedAccounts: compromisedAccounts.current.value,
			passwordsLeaked: passwordsLeaked.current.value,
			dataItemsLeaked: dataItemsLeaked.current.value
		};
		const clearbit = (showClearbitToggle && useClearbitLogo);
		props.onSubmit(props.company, darkWebDetails, clearbit, advanced);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit(false);
	};
	
	const handleCancel = () => {
		setHideImage(false);
		setShowClearbitToggle(false);
		props.onClose()
	};
	
	const handleBreachAwareClick = () => {
		window.open(`https://breachaware.com/scan/domain/${props.company.domain}`)
	};
	
	const handleClearbitSwitch = (event) => {
		setUseClearbitLogo(event.target.checked);
	}
	
	const handleImageLoad = () => {
		setShowClearbitToggle(true);
	}
	
	const handleImageError = () => {
		setHideImage(true);
	}
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		flexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.company}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Generate Exposure Report
			</DialogTitle>
			<DialogContent>
				{ props.loading &&
					<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
						<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
					</Box>
				}
				{ !props.loading &&
					<form id="exposureForm" onSubmit={handleSubmitForm} autoComplete="off">
						{props.company && props.company.domain?
							<Box>
								<Box sx={{ textAlign: "center", marginBottom: "3em" }}>
									<Button sx={formControlStyle} onClick={handleBreachAwareClick}>
										Open Breach Aware Public Report
									</Button>
								</Box>
								<Box sx={{ marginBottom: "2em" }}>
									{!hideImage?
										<Box sx={{ marginLeft: "3em" }}>
											<img
												src={`https://logo.clearbit.com/${props.company.domain}`}
												alt="logo"
												onLoad={handleImageLoad}
												onError={handleImageError}
											/>
										</Box>
									:<React.Fragment/>}
									{(showClearbitToggle && !hideImage)?
										<FormGroup sx={formControlStyle}>
											<FormControlLabel
												control={
													<Switch
													checked={useClearbitLogo}
													onChange={handleClearbitSwitch}
													/>
												}
												label="Use Clearbit Logo"
												/>
										</FormGroup>
									:<React.Fragment/>}
								</Box>
							</Box>
						: ""}
						<FormControl required="true" sx={formControlStyle}>
							<InputLabel htmlFor="compromisedAccounts">Compromised Accounts</InputLabel>
							<Input
								inputRef={compromisedAccounts}
								id="compromisedAccounts"
								type="compromisedAccounts"
								autoComplete="off"
								defaultValue=""
								required
							/>
						</FormControl>
						<FormControl required="true" sx={formControlStyle}>
							<InputLabel htmlFor="dataItemsLeaked">Data Items Leaked</InputLabel>
							<Input
								inputRef={dataItemsLeaked}
								id="dataItemsLeaked"
								type="dataItemsLeaked"
								autoComplete="off"
								defaultValue=""
								required
							/>
						</FormControl>
						<FormControl required="true" sx={formControlStyle}>
							<InputLabel htmlFor="passwordsLeaked">Passwords Leaked</InputLabel>
							<Input
								inputRef={passwordsLeaked}
								id="passwordsLeaked"
								type="passwordsLeaked"
								autoComplete="off"
								defaultValue=""
								required
							/>
						</FormControl>
					</form>
				}
			</DialogContent>
			{ !props.loading &&
				<DialogActions>
					<Button onClick={handleCancel}>Cancel</Button>
					<Button onClick={handleAdvanced}>Advanced</Button>
					<Button type="submit" form="exposureForm" autoFocus>Basic</Button>
				</DialogActions>
			}
		</Dialog>
	);
};

export default ExposureReportModal;